"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(shadowIncludingInclusiveDescendantsIterator),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(shadowIncludingDescendantsIterator);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var NODE_TYPE = require("../node-type");

var _require = require("./node"),
    nodeRoot = _require.nodeRoot;

var _require2 = require("./namespaces"),
    HTML_NS = _require2.HTML_NS;

var _require3 = require("./internal-constants"),
    domSymbolTree = _require3.domSymbolTree;

var _require4 = require("./mutation-observers"),
    signalSlotList = _require4.signalSlotList,
    queueMutationObserverMicrotask = _require4.queueMutationObserverMicrotask; // Valid host element for ShadowRoot.
// Defined in: https://dom.spec.whatwg.org/#dom-element-attachshadow


var VALID_HOST_ELEMENT_NAME = new Set(["article", "aside", "blockquote", "body", "div", "footer", "h1", "h2", "h3", "h4", "h5", "h6", "header", "main", "nav", "p", "section", "span"]);

function isValidHostElementName(name) {
  return VALID_HOST_ELEMENT_NAME.has(name);
} // Use an approximation by checking the presence of nodeType instead of instead of using the isImpl from
// "../generated/Node" to avoid introduction of circular dependencies.


function isNode(nodeImpl) {
  return Boolean(nodeImpl && "nodeType" in nodeImpl);
} // Use an approximation by checking the value of nodeType and presence of nodeType host instead of instead
// of using the isImpl from "../generated/ShadowRoot" to avoid introduction of circular dependencies.


function isShadowRoot(nodeImpl) {
  return Boolean(nodeImpl && nodeImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE && "host" in nodeImpl);
} // https://dom.spec.whatwg.org/#concept-slotable


function isSlotable(nodeImpl) {
  return nodeImpl && (nodeImpl.nodeType === NODE_TYPE.ELEMENT_NODE || nodeImpl.nodeType === NODE_TYPE.TEXT_NODE);
}

function isSlot(nodeImpl) {
  return nodeImpl && nodeImpl.localName === "slot" && nodeImpl._namespaceURI === HTML_NS;
} // https://dom.spec.whatwg.org/#concept-shadow-including-inclusive-ancestor


function isShadowInclusiveAncestor(ancestor, node) {
  while (isNode(node)) {
    if (node === ancestor) {
      return true;
    }

    if (isShadowRoot(node)) {
      node = node.host;
    } else {
      node = domSymbolTree.parent(node);
    }
  }

  return false;
} // https://dom.spec.whatwg.org/#retarget


function retarget(a, b) {
  while (true) {
    if (!isNode(a)) {
      return a;
    }

    var aRoot = nodeRoot(a);

    if (!isShadowRoot(aRoot) || isNode(b) && isShadowInclusiveAncestor(aRoot, b)) {
      return a;
    }

    a = nodeRoot(a).host;
  }
} // https://dom.spec.whatwg.org/#get-the-parent


function getEventTargetParent(eventTarget, event) {
  // _getTheParent will be missing for Window, since it doesn't have an impl class and we don't want to pollute the
  // user-visible global scope with a _getTheParent value. TODO: remove this entire function and use _getTheParent
  // directly, once Window gets split into impl/wrapper.
  return eventTarget._getTheParent ? eventTarget._getTheParent(event) : null;
} // https://dom.spec.whatwg.org/#concept-shadow-including-root


function shadowIncludingRoot(node) {
  var root = nodeRoot(node);
  return isShadowRoot(root) ? shadowIncludingRoot(root.host) : root;
} // https://dom.spec.whatwg.org/#assign-a-slot


function assignSlot(slotable) {
  var slot = findSlot(slotable);

  if (slot) {
    assignSlotable(slot);
  }
} // https://dom.spec.whatwg.org/#assign-slotables


function assignSlotable(slot) {
  var slotables = findSlotable(slot);
  var shouldFireSlotChange = false;

  if (slotables.length !== slot._assignedNodes.length) {
    shouldFireSlotChange = true;
  } else {
    for (var i = 0; i < slotables.length; i++) {
      if (slotables[i] !== slot._assignedNodes[i]) {
        shouldFireSlotChange = true;
        break;
      }
    }
  }

  if (shouldFireSlotChange) {
    signalSlotChange(slot);
  }

  slot._assignedNodes = slotables;

  var _iterator = _createForOfIteratorHelper(slotables),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var slotable = _step.value;
      slotable._assignedSlot = slot;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
} // https://dom.spec.whatwg.org/#assign-slotables-for-a-tree


function assignSlotableForTree(root) {
  var _iterator2 = _createForOfIteratorHelper(domSymbolTree.treeIterator(root)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var slot = _step2.value;

      if (isSlot(slot)) {
        assignSlotable(slot);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
} // https://dom.spec.whatwg.org/#find-slotables


function findSlotable(slot) {
  var result = [];
  var root = nodeRoot(slot);

  if (!isShadowRoot(root)) {
    return result;
  }

  var _iterator3 = _createForOfIteratorHelper(domSymbolTree.treeIterator(root.host)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var slotable = _step3.value;
      var foundSlot = findSlot(slotable);

      if (foundSlot === slot) {
        result.push(slotable);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return result;
} // https://dom.spec.whatwg.org/#find-flattened-slotables


function findFlattenedSlotables(slot) {
  var result = [];
  var root = nodeRoot(slot);

  if (!isShadowRoot(root)) {
    return result;
  }

  var slotables = findSlotable(slot);

  if (slotables.length === 0) {
    var _iterator4 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(slot)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var child = _step4.value;

        if (isSlotable(child)) {
          slotables.push(child);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  var _iterator5 = _createForOfIteratorHelper(slotables),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var node = _step5.value;

      if (isSlot(node) && isShadowRoot(nodeRoot(node))) {
        var temporaryResult = findFlattenedSlotables(node);
        result.push.apply(result, _toConsumableArray(temporaryResult));
      } else {
        result.push(node);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return result;
} // https://dom.spec.whatwg.org/#find-a-slot


function findSlot(slotable, openFlag) {
  var parent = slotable.parentNode;

  if (!parent) {
    return null;
  }

  var shadow = parent._shadowRoot;

  if (!shadow || openFlag && shadow.mode !== "open") {
    return null;
  }

  var _iterator6 = _createForOfIteratorHelper(domSymbolTree.treeIterator(shadow)),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var child = _step6.value;

      if (isSlot(child) && child.name === slotable._slotableName) {
        return child;
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return null;
} // https://dom.spec.whatwg.org/#signal-a-slot-change


function signalSlotChange(slot) {
  if (!signalSlotList.some(function (entry) {
    return entry === slot;
  })) {
    signalSlotList.push(slot);
  }

  queueMutationObserverMicrotask();
} // https://dom.spec.whatwg.org/#concept-shadow-including-descendant


function shadowIncludingInclusiveDescendantsIterator(node) {
  var _iterator7, _step7, child;

  return _regeneratorRuntime.wrap(function shadowIncludingInclusiveDescendantsIterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return node;

        case 2:
          if (!node._shadowRoot) {
            _context.next = 4;
            break;
          }

          return _context.delegateYield(shadowIncludingInclusiveDescendantsIterator(node._shadowRoot), "t0", 4);

        case 4:
          _iterator7 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(node));
          _context.prev = 5;

          _iterator7.s();

        case 7:
          if ((_step7 = _iterator7.n()).done) {
            _context.next = 12;
            break;
          }

          child = _step7.value;
          return _context.delegateYield(shadowIncludingInclusiveDescendantsIterator(child), "t1", 10);

        case 10:
          _context.next = 7;
          break;

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t2 = _context["catch"](5);

          _iterator7.e(_context.t2);

        case 17:
          _context.prev = 17;

          _iterator7.f();

          return _context.finish(17);

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[5, 14, 17, 20]]);
} // https://dom.spec.whatwg.org/#concept-shadow-including-descendant


function shadowIncludingDescendantsIterator(node) {
  var _iterator8, _step8, child;

  return _regeneratorRuntime.wrap(function shadowIncludingDescendantsIterator$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!node._shadowRoot) {
            _context2.next = 2;
            break;
          }

          return _context2.delegateYield(shadowIncludingInclusiveDescendantsIterator(node._shadowRoot), "t0", 2);

        case 2:
          _iterator8 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(node));
          _context2.prev = 3;

          _iterator8.s();

        case 5:
          if ((_step8 = _iterator8.n()).done) {
            _context2.next = 10;
            break;
          }

          child = _step8.value;
          return _context2.delegateYield(shadowIncludingInclusiveDescendantsIterator(child), "t1", 8);

        case 8:
          _context2.next = 5;
          break;

        case 10:
          _context2.next = 15;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t2 = _context2["catch"](3);

          _iterator8.e(_context2.t2);

        case 15:
          _context2.prev = 15;

          _iterator8.f();

          return _context2.finish(15);

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[3, 12, 15, 18]]);
}

module.exports = {
  isValidHostElementName: isValidHostElementName,
  isNode: isNode,
  isSlotable: isSlotable,
  isSlot: isSlot,
  isShadowRoot: isShadowRoot,
  isShadowInclusiveAncestor: isShadowInclusiveAncestor,
  retarget: retarget,
  getEventTargetParent: getEventTargetParent,
  shadowIncludingRoot: shadowIncludingRoot,
  assignSlot: assignSlot,
  assignSlotable: assignSlotable,
  assignSlotableForTree: assignSlotableForTree,
  findSlot: findSlot,
  findFlattenedSlotables: findFlattenedSlotables,
  signalSlotChange: signalSlotChange,
  shadowIncludingInclusiveDescendantsIterator: shadowIncludingInclusiveDescendantsIterator,
  shadowIncludingDescendantsIterator: shadowIncludingDescendantsIterator
};